module.exports = __webpack_public_path__ + "static/media/biopic.e21ad79b.png";